import React from "react";
import { Box, Typography } from "@mui/material";

const TableTop = ({ count, variant }) => {
  const isTransparent = variant === "TRANSPARENT";

  return (
    <Box sx={getStyles.container(isTransparent)}>
      <Typography variant="h6" component="div">
        Ukupno : {count}
      </Typography>
    </Box>
  );
};

export default TableTop;

const getStyles = {
  container: (isTransparent) => ({
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: 2,
    backgroundColor: isTransparent ? "transparent" : "#f5f5f5",
    borderBottom: isTransparent ? "none" : "1px solid rgba(0,0,0,0.12)",
  }),
};
